import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Sign in failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 fade-up">
      <div className="bg-white rounded-2xl border border-stone-200 shadow-sm p-8">
        <span className="w-12 h-12 rounded-2xl bg-[#E8EFE9] text-[#2E604A] flex items-center justify-center mb-4">
          <Lock className="w-6 h-6" />
        </span>
        <h1 className="font-display text-2xl font-bold text-stone-900 mb-6">{t("login_title")}</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-sm font-semibold mb-1.5 block">{t("login_email")}</Label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl h-11" />
          </div>
          <div>
            <Label className="text-sm font-semibold mb-1.5 block">{t("login_password")}</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl h-11" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-[#C05E4B] font-medium">{error}</p>}
          <Button type="submit" data-testid="login-btn" disabled={loading}
            className="w-full rounded-full bg-[#2E604A] hover:bg-[#234B3A] h-11 font-semibold">
            {t("login_btn")}
          </Button>
        </form>
      </div>
    </div>
  );
}
